
  import React from "react"
  import Component from "/Users/etalli/Documents/Work/MSC/Web/csc/csc/src/layouts/index.js"
  import data from "/Users/etalli/Documents/Work/MSC/Web/csc/csc/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js